import $ from "jquery";
// INSTRUCTION

export class InstructionCustomization {
    constructor() {
        // Instruction on/off instant update
        const original = $('[name="variant[instruction_display]"]:checked').val()

        $('[name="variant[enable_instruction]"]').change(function () {
            if (!this.checked) {
                $('[name="variant[instruction_display]"]').filter("[value=never]").prop('checked', true).trigger('change')
            } else {
                // When the instruction is changed from off to on, preselect "always" if nothing is selected
                if (!$('[name="variant[instruction_display]"]:checked').length) {
                    $('[name="variant[instruction_display]"]').filter("[value=always]").prop('checked', true).trigger('change')
                }
            }
        })

        // Instruction display instant update
        $('[name="variant[instruction_display]"]').change(function () {
            viewer().instruction_display(this.value)
        })

        // Instruction background instant update
        $('[name="variant[instruction_background]"]').change(function () {
            viewer().instruction_background(this.value)
        })

        // Instruction position instant update
        $('[name="variant[instruction_position]"]').change(function () {
            viewer().instruction_position(this.value)
        })

        // Instruction language instant update
        $('[name="variant[instruction_language]"]').change(function () {
            viewer().instruction_language(this.value)
        })
    }
}